import { useLogin } from '@/ui/hooks/auth/useLogin';
import { useCurrentUserState } from '@/ui/hooks/use-current-user-state';

/**
 * How the buy button behaves for an item: as usual, disabled while the current user is not known
 * yet (so the login buttons don't flash for members), or replaced by the club buttons.
 */
export type ClubOnlyPurchaseGate = 'open' | 'waiting' | 'club-actions';

/** The buy button state for an item and the login the club buttons offer. */
export function useClubOnlyPurchase(isClubOnly: boolean) {
  const currentUser = useCurrentUserState();
  const { login } = useLogin();

  let gate: ClubOnlyPurchaseGate = 'club-actions';
  if (!isClubOnly || currentUser?.isClubMember) {
    gate = 'open';
  } else if (!currentUser) {
    gate = 'waiting';
  }

  return {
    gate,
    isLoggedIn: !!currentUser?.isLoggedIn,
    // Back to the same page (and chooser state) after logging in.
    logInToUnlock: () => login(globalThis.location.href),
  };
}
